import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistForm, useChecklistFormActions } from '../../_form/ChecklistFormHandler'
import CheckboxInput from '../../../../../components/form/CheckboxInput'

const EmailSection = () => {
  const form = useChecklistForm()
  const { handleChange } = useChecklistFormActions()
  const { t } = useTranslation('editChecklist')

  const commonProps = { handleChange, form, t }

  return (
    <CheckboxInput
      label={t('fieldsStep.sendEmail')}
      value={form.emailNotificationEnabled}
      onChange={value => handleChange('emailNotificationEnabled', value)}
      {...commonProps}
    />
  )
}

export default EmailSection
